import { render, staticRenderFns } from "./talents_manage.vue?vue&type=template&id=92a4cdf6&scoped=true"
import script from "./talents_manage.vue?vue&type=script&lang=js"
export * from "./talents_manage.vue?vue&type=script&lang=js"
import style0 from "./talents_manage.vue?vue&type=style&index=0&id=92a4cdf6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a4cdf6",
  null
  
)

export default component.exports